import React, { createContext, useContext, useState } from 'react';
import { SavedSyncAudiobook } from '../services/syncAudiobookStorage';
import { SyncedAudiobookPlayer } from '../components/SyncedAudiobookPlayer';

interface SyncedAudiobookContextType {
  activeAudiobook: SavedSyncAudiobook | null;
  playAudiobook: (audiobook: SavedSyncAudiobook) => void;
  closeAudiobook: () => void;
}

const SyncedAudiobookContext = createContext<SyncedAudiobookContextType>({
  activeAudiobook: null,
  playAudiobook: () => {},
  closeAudiobook: () => {},
});

export const SyncedAudiobookProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [activeAudiobook, setActiveAudiobook] = useState<SavedSyncAudiobook | null>(null);

  const playAudiobook = (audiobook: SavedSyncAudiobook) => {
    setActiveAudiobook(audiobook);
  };

  const closeAudiobook = () => {
    setActiveAudiobook(null);
  };

  return (
    <SyncedAudiobookContext.Provider value={{ activeAudiobook, playAudiobook, closeAudiobook }}>
      {children}
      {activeAudiobook && (
        <SyncedAudiobookPlayer
          key={activeAudiobook.id}
          audiobook={activeAudiobook}
          onClose={closeAudiobook}
        />
      )}
    </SyncedAudiobookContext.Provider>
  );
};

export const useSyncedAudiobook = () => useContext(SyncedAudiobookContext);
